import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export const H2 = ({ children }) => (
    <h2 className="font-display text-2xl sm:text-3xl text-[#0d3d2e] pt-6">{children}</h2>
);

export const P = ({ children }) => (
    <p className="text-[15px] leading-relaxed text-[#1a1a1a]/80">{children}</p>
);

export const UL = ({ items }) => (
    <ul className="list-disc pl-6 space-y-2 text-[15px] leading-relaxed text-[#1a1a1a]/80">
        {items.map((it, i) => (
            <li key={i}>{it}</li>
        ))}
    </ul>
);

export const B = ({ children }) => <strong className="text-[#0d3d2e] font-semibold">{children}</strong>;

export default function LegalLayout({ title, updated, children }) {
    return (
        <div className="min-h-screen bg-[#fcfbf8]">
            <header className="border-b border-[#0d3d2e]/10">
                <div className="max-w-3xl mx-auto px-6 h-20 flex items-center justify-between">
                    <Link to="/" data-testid="legal-logo-link">
                        <img src="/logo.png" alt="OPTIM SAFE" className="h-10 w-auto object-contain" />
                    </Link>
                    <Link
                        to="/"
                        data-testid="legal-back-link"
                        className="inline-flex items-center gap-2 text-sm font-medium text-[#0d3d2e] hover:opacity-70 transition-opacity"
                    >
                        <ArrowLeft className="h-4 w-4" strokeWidth={1.75} /> Înapoi la site
                    </Link>
                </div>
            </header>
            <main className="max-w-3xl mx-auto px-6 py-14" data-testid="legal-page">
                <h1 className="font-display text-4xl sm:text-5xl text-[#0d3d2e] leading-tight mb-2">{title}</h1>
                <p className="text-sm text-[#1a1a1a]/55 mb-10">Ultima actualizare: {updated}</p>
                <div className="space-y-5">{children}</div>
            </main>
            <footer className="border-t border-[#0d3d2e]/10 py-8 text-center text-xs text-[#1a1a1a]/50">
                © {new Date().getFullYear()} OPTIM SAFE — Toate drepturile rezervate.
            </footer>
        </div>
    );
}
